import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/promoCode', request)
}

export {get}
